import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsTableComponent } from './reports-table/reports-table.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/app/material/material.module';
import { LoaderModule } from '../loader/loader.module';
import { FormsModule } from '@angular/forms';
import { NewReportRequestFormComponent } from './new-report-request-form/new-report-request-form.component';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { QuillModule } from 'ngx-quill';
import { ControlsModule } from '../controls/controls.module';



@NgModule({
    declarations: [
        ReportsTableComponent,
        NewReportRequestFormComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MaterialModule,
        FlexLayoutModule,
        LoaderModule,
        FormFieldsModule,
        ControlsModule,
        QuillModule.forRoot(),
    ],
    exports: [
        ReportsTableComponent,
        NewReportRequestFormComponent,
    ]
})
export class ReportsModule { }
